<template>
  <div class="homePage">
    <header id="header">
      <div class="container">
        <div class="menu-mobile">
          <img src="@/assets/menu-hamburguer.svg" alt="Menu mobile" />
        </div>

        <a href="#carousel" class="header__link">
          <img src="@/assets/logo.svg" alt="Logo Adapt-e" class="logo__icon" />
        </a>

        <div class="right-side">
          <nav class="nav">
            <ul class="nav__list">
              <li class="nav__item">Mussum</li>
              <li class="nav__item">
                <a href="#testemunhos">Depoimentos</a>
              </li>
              <li class="nav__item">
                <a href="#planos"> Planos </a>
              </li>
              <li class="nav__item">
                <a href="#newsletter"> Newsletter </a>
              </li>
            </ul>
          </nav>

          <input class="header__input" type="text" />

          <button class="button-singIn" @click="openModalLogin">Entrar</button>
          <button class="button-singUp" @click="openModalCadastro">
            Cadastre-se
          </button>
        </div>
      </div>
    </header>

    <section id="carousel">
      <carousel
        :per-page="1"
        :autoplay="true"
        :autoplay-timeout="3000"
        :loop="true"
      >
        <slide>
          <h1>Mussum Ipsum, caclids vidis litro abertis.</h1>
          <p>
            Interagi no mé, cursus quis, vehicula ac nisi. Quem num gosta di mim
            que vai caçá sua turmis!
          </p>
        </slide>

        <slide>
          <h1>Mussum Ipsum</h1>
          <p>Quem num gosta di mé</p>
        </slide>
      </carousel>
    </section>

    <section id="video">
      <div>
        <h1 class="title">Pindureta</h1>
        <p>
          Mussum Ipsum, cacilds vidis litro abertis. Cevadis im ampola pa arma
          uma pindureta. Praesent vel viverra nisi. Mauris aliquet nunc non
          turpis scelerisque, eget. Posuere libero varius. Nullam a nisl ut ante
          blandit hendrerit. Aenean sit amet nisi. Aenean aliquam molestie leo,
          vitae iaculis nisl.
        </p>

        <p>
          Quem num gosta di mé, boa gentis num é. Casamentiss faiz malandris se
          pirulitá. Interagi no mé, cursus quis, vehicula ac nisi. Diuretics
          paradis num copo é motivis de denguis.
        </p>
      </div>

      <div class="video" />
    </section>

    <section id="testemunhos">
      <div class="container">
        <div class="header">
          <h2>Mussum Ipsum</h2>
          <h1>Quem num gosta di mé</h1>
        </div>

        <div class="testemunhos">
          <div class="testemunho">
            <span class="testemunho__title">Form, function, feeling</span>
            <p>
              Interagi no mé, cursus quis, vehicula ac nisi. Diuretics paradis
              num copo é motivis de denguis.
            </p>
          </div>

          <div class="testemunho">
            <span class="testemunho__title">Paradiz num copo</span>
            <p>
              Interagi no mé, cursus quis, vehicula ac nisi. Diuretics paradis
              num copo é motivis de denguis.
            </p>
          </div>

          <div class="testemunho">
            <span class="testemunho__title">Boa gentiz num é</span>
            <p>
              Interagi no mé, cursus quis, vehicula ac nisi. Diuretics paradis
              num copo é motivis de denguis.
            </p>
          </div>

          <div class="testemunho">
            <span class="testemunho__title">Suco de cevadis</span>
            <p>
              Interagi no mé, cursus quis, vehicula ac nisi. Diuretics paradis
              num copo é motivis de denguis.
            </p>
          </div>
        </div>

        <div class="social">
          <img src="@/assets/icons/social-media/facebook.svg" />
          <img src="@/assets/icons/social-media/twitter.svg" />
          <img src="@/assets/icons/social-media/instagram.svg" />
        </div>
      </div>
    </section>

    <section id="prints">
      <div>
        <h1>Suco de cevadis deixa as</h1>
        <p>
          Suco de cevadiss, é um leite divinis, qui tem lupuliz, matis, aguis e
          fermentis. Delegadis gente finis, bibendum egestas augue arcu ut est.
        </p>
      </div>
    </section>

    <section id="planos">
      <div class="container">
        <div class="plano">
          <span class="plano__title">Pessoal</span>
          <span class="plano__preco">R$ 35</span>

          <p class="plano__descricao">
            Suco de cevadiss, é um leite divinis, qui
          </p>

          <ul class="plano__list">
            <li class="plano__list-item">fermentis</li>
            <li class="plano__list-item">commodo</li>
            <li class="plano__list-item">10 Videos</li>
            <li class="plano__list-item">cacilds vidis litro</li>
          </ul>

          <button @click="()=> this.$router.push('/plano/pessoal')" class="plano__button">Comprar</button>
        </div>

        <div class="plano">
          <span class="plano__title">Básico</span>
          <span class="plano__preco">R$ 56</span>

          <p class="plano__descricao">
            Suco de cevadiss, é um leite divinis, qui
          </p>

          <ul class="plano__list">
            <li class="plano__list-item">fermentis</li>
            <li class="plano__list-item">commodo</li>
            <li class="plano__list-item">10 Videos</li>
            <li class="plano__list-item">cacilds vidis litro</li>
          </ul>

          <button @click="()=> this.$router.push('/plano/basico')" class="plano__button">Comprar</button>
        </div>

        <div class="plano">
          <span class="plano__title">Pro</span>
          <span class="plano__preco">R$ 130</span>

          <p class="plano__descricao">
            Suco de cevadiss, é um leite divinis, qui
          </p>

          <ul class="plano__list">
            <li class="plano__list-item">fermentis</li>
            <li class="plano__list-item">commodo</li>
            <li class="plano__list-item">10 Videos</li>
            <li class="plano__list-item">cacilds vidis litro</li>
          </ul>

          <button @click="()=> this.$router.push('/plano/pro')" class="plano__button">Comprar</button>
        </div>

        <div class="plano">
          <span class="plano__title">Ilimitado</span>
          <span class="plano__preco">R$ 290</span>

          <p class="plano__descricao">
            Suco de cevadiss, é um leite divinis, qui
          </p>

          <ul class="plano__list">
            <li class="plano__list-item">fermentis</li>
            <li class="plano__list-item">commodo</li>
            <li class="plano__list-item">10 Videos</li>
            <li class="plano__list-item">cacilds vidis litro</li>
          </ul>

          <button @click="()=> this.$router.push('/plano/ilimitado')" class="plano__button">Comprar</button>
        </div>
      </div>
    </section>

    <section id="donos">
      <h1 class="title">Suco de cevadis deixa</h1>
      <p>
        Suco de cevadiss deixa as pessoas mais interessantis. Diuretics paradis
        num copo é motivis de denguis. Suco de cevadiss, é um leite divinis, qui
        tem lupuliz, matis, aguis e fermentis. Delegadis gente finis, bibendum
        egestas augue arcu ut est.
      </p>

      <div>
        <span class="autor">John Doe</span>
        <span class="role">CEO of getdough</span>
      </div>

      <div>
        <img src="@/assets/avatar/avatar-profile.svg" width="60" />
        <img src="@/assets/avatar/avatar-profile.svg" width="60" />
        <img src="@/assets/avatar/avatar-profile.svg" width="60" />
      </div>
    </section>

    <section id="banner">
      <div class="photo" />
      <div>
        <h1 class="title">Pindureta</h1>
        <p>
          Mussum Ipsum, cacilds vidis litro abertis. Cevadis im ampola pa arma
          uma pindureta. Praesent vel viverra nisi. Mauris aliquet nunc non
          turpis scelerisque, eget. Posuere libero varius. Nullam a nisl ut ante
          blandit hendrerit. Aenean sit amet nisi. Aenean aliquam molestie leo,
          vitae iaculis nisl.
        </p>

        <p>
          Quem num gosta di mé, boa gentis num é. Casamentiss faiz malandris se
          pirulitá. Interagi no mé, cursus quis, vehicula ac nisi. Diuretics
          paradis num copo é motivis de denguis.
        </p>
      </div>
    </section>

    <section id="newsletter">
      <div class="newsletter">
        <h1 class="newsletter__title">Mussum Ipsum</h1>

        <p class="newsletter__descricao">
          cacilds vidis litro abertis. Si num tem leite então bota uma pinga aí
          cumpadi! Viva Forevis aptent taciti sociosqu ad litora torquent.
        </p>

        <form class="newsletter__form" @submit.prevent="submitSubscrition">
          <input
            v-model="emailNewsletter"
            type="email"
            placeholder="adicione seu e-mail"
            required
            class="newsletter__input"
          />
          <button class="newsletter__button">Enviar</button>
        </form>
      </div>
    </section>

    <footer id="footer">
      <div class="footer">
        <img
          class="footer__logo"
          src="@/assets/branding/logo-white-background.svg"
          width="137px"
        />

        <ul class="footer__list">
          <li class="footer__list-item">Mussum</li>
          <li class="footer__list-item">Consequat</li>
          <li class="footer__list-item">Santis</li>
          <li class="footer__list-item">Tombis</li>
        </ul>

        <p class="footer__descricao">
          In elementis mé pra quem é amistosis quis leo. Si u mundo tá muito
          paradis? Toma um mé que o mundo vai girarzis! Não sou faixa preta
          cumpadi, sou preto inteiris, inteiris.
        </p>

        <div class="footer__social">
          <a
            href="https://facebook.com"
            class="footer__social-item"
            target="blank"
          >
            <img src="@/assets/icons/social-media/facebook.svg" />
          </a>
          <a
            href="https://twitter.com"
            class="footer__social-item"
            target="blank"
          >
            <img src="@/assets/icons/social-media/twitter.svg" />
          </a>
          <a
            href="https://instagram.com"
            class="footer__social-item"
            target="blank"
          >
            <img src="@/assets/icons/social-media/instagram.svg" />
          </a>
        </div>
      </div>
    </footer>

    <Modal />
  </div>
</template>

<script>
import Modal from '@/views/layout/modal';
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'Home',
  components: {
    Modal,
    Carousel,
    Slide,
  },
  emits: ['modal'],
  data() {
    return {
      login: false,
      cadastro: false,
      warning: false,

      settings: {
        dots: true,
        dotsClass: 'slick-dots custom-dot-class',
        edgeFriction: 0.35,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        centerMode: false,
      },

      emailNewsletter: '',
    };
  },
  mounted() {
    document.querySelectorAll('.plano').forEach((plano) => {
      plano.addEventListener('mouseover', () => {
        plano.classList.add('ativo');
      });

      plano.addEventListener('mouseout', () => {
        plano.classList.remove('ativo');
      });
    });

    this.$root.$on('warning', () => {
      console.log('Ouvi o warning');
      setTimeout(() => {
        this.$root.$emit('modal', {
          component: 'home/Warning.vue',
        });
      }, 1000);
    });
  },
  methods: {
    openModalLogin() {
      this.$router.push('/entrar?tab=0');
      // this.$root.$emit('modal', {
      //   component: 'home/Login.vue'
      // })
    },
    openModalCadastro() {
      this.$router.push('/entrar?tab=1');
      // this.$root.$emit('modal', {
      //   component: 'home/NewAccount.vue'
      // })
    },
    showWarning() {
      this.warning = !this.warning;
    },
    submitSubscrition() {
      console.log('Hello, new subscriber!', this.emailNewsletter);

      this.emailNewsletter = '';
    },
    redirect() {
      this.$router.push('/admin');
    },
  },
};
</script>

<style scoped lang="scss">
.homePage {
  #header {
    background: #1226aa;
    height: 80px;
    display: flex;
    color: white;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 100;

    .container {
      display: flex;
      max-width: 1138px;
      padding: 0 0px;
      width: 100%;
      margin: 0 auto;
      justify-content: space-between;

      .menu-mobile {
        display: none;
        cursor: pointer;
      }

      .header__link {
        .logo__icon {
          cursor: pointer;
          width: 137px;
        }
      }

      .right-side {
        display: flex;

        .nav {
          display: flex;
          justify-content: center;
          align-items: center;

          .nav__list {
            text-transform: uppercase;
            list-style: none;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;

            .nav__item {
              margin: 0 15px;
              cursor: pointer;

              &:hover {
                font-weight: 700;
                transform: scale(1.1);
              }
            }
          }
        }

        .header__input {
          width: 70px;
          height: 40px;
          padding: 10px 17px;
          border-radius: 90px;
          border: none;
          background: #3344b6 url('../../../assets/icons/search.svg') right 17px
            center no-repeat;
          color: #fff;
          margin-right: 20px;
          margin: auto;
          transition: all 0.5s;

          &:focus {
            width: 360px;
            outline: none;
          }
        }

        button {
          width: 118px;
          height: 32px;
          margin: auto 0;
          border-radius: 80px;
          border: none;
          font-family: 'Roboto', sans-serif;
          cursor: pointer;
          font-size: 12px;

          &.button-singIn {
            background: transparent;
            color: #eaf7ff;
            border: 1px solid #eaf7ff;
            margin: auto 10px;
          }
        }
      }
    }
  }

  #carousel {
    margin-top: 80px;
    text-align: center;

    div {
      height: 700px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      h1 {
        text-transform: uppercase;
        color: #1e2e42;
        width: 100%;
        max-width: 890px;
        margin: 0 auto;
        font-weight: 400;
        line-height: 70px;
        font-size: 60px;
        margin-bottom: 26px;
      }

      p {
        color: #617283;
        font-size: 26px;
        width: 100%;
        max-width: 776px;
        margin: 0 auto;
        line-height: 40px;
        font-weight: 400;
      }
    }
  }

  #video {
    display: flex;
    justify-content: center;

    div {
      width: 50%;
      background: #1226aa;
      color: white;
      height: 700px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 25px;

      .title {
        color: white;
        text-transform: uppercase;
        font-size: 70px;
        line-height: 66px;
        letter-spacing: 1px;
        font-weight: 400;
        width: 100%;
        max-width: 458px;
        margin: 0 auto;
        margin-bottom: 35px;

        &::before {
          content: '';
          display: inline-block;
          width: 6px;
          height: 30px;
          margin-right: 18px;
          background: #2ed9c3;
        }
      }

      p {
        font-size: 20px;
        margin: 15px auto;
        width: 100%;
        max-width: 458px;
        line-height: 28px;
      }
    }

    .video {
      background: #d8d8d8;
    }
  }

  #testemunhos {
    .container {
      width: 100%;
      max-width: 1138px;
      margin: 0 auto;
      height: 650px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 70px 0;

      .header {
        h2 {
          text-transform: uppercase;
          font-family: 'Roboto 500', sans-serif;
          color: #aab1b9;
          font-size: 28px;
          letter-spacing: 1px;
          line-height: 44px;
          font-weight: 500;
        }

        h1 {
          text-transform: uppercase;
          color: #1e2e42;
          line-height: 50px;
          font-weight: 400;
          font-size: 50px;
        }
      }

      .testemunhos {
        display: flex;
        flex-wrap: wrap;

        .testemunho {
          width: 50%;
          height: 175px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .testemunho__title {
            text-transform: uppercase;
            font-weight: 700;
            color: #1e2e42;
            font-size: 20px;
            align-self: baseline;
          }

          p {
            color: #617283;
            font-size: 16px;
            line-height: 22px;
            margin-top: 18px;
          }
        }
      }

      .social {
        img {
          margin: 0 10px;
          cursor: pointer;
        }

        img:first-child {
          margin-left: 0;
        }
      }
    }
  }

  #prints {
    text-align: center;
    background: #1226aa;
    color: #fff;
    padding: 40px 0;

    div {
      height: 660px;

      h1 {
        color: white;
        text-transform: uppercase;
        font-weight: 400;
        letter-spacing: 1px;
        line-height: 70px;
        font-size: 50px;
      }

      p {
        font-size: 20px;
        font-weight: 400;
        line-height: 28px;
        width: 100%;
        max-width: 672px;
        margin: 0 auto;
      }
    }
  }

  #planos {
    .container {
      width: 100%;
      max-width: 1138px;
      margin: 0 auto;
      display: flex;
      padding: 60px 0;
      position: relative;

      .plano {
        background: #f7f8f8;
        text-align: center;
        padding: 25px;
        height: 430px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        cursor: pointer;
        transition: all 0.3s;

        span {
          display: block;
        }

        &__title {
          color: #1e2e42;
          font-weight: 500;
          font-size: 22px;
          font-family: 'Roboto 500', sans-serif;
        }

        &__preco {
          color: #3b495b;
          font-size: 45px;
          font-family: 'Roboto 300', sans-serif;
        }

        &__descricao {
          color: #aab1b9;
          font-size: 18px;
        }

        &__list {
          list-style: none;

          &-item {
            margin: 30px 0;
            color: #617283;
            font-size: 18px;
            line-height: 22px;
          }
        }

        &__button {
          background: #38ba72;
            border: none;
            color: #fff;
            font-size: 18px;
            border-radius: 3px;
            width: 100%;
            max-width: 165px;
            margin: 0 auto;
            padding: 10px 15px;
            height: 52px;
            display: block;
            cursor: pointer;
          
        }

        &.ativo {
          background: #ffffff;
          border: 1px solid #C4C4C4;

          // button {
          //   background: #38ba72;
          //   border: none;
          //   color: #fff;
          //   font-size: 18px;
          //   border-radius: 3px;
          //   width: 100%;
          //   max-width: 165px;
          //   margin: 0 auto;
          //   padding: 10px 15px;
          //   height: 52px;
          //   display: block;
          // }
        }

        button:hover {
          transform: scale(1.2);
          background:#0F8FD9;
        }
        &:hover {
          transform: scale(1.09);
        }
      }
    }
  }

  #donos {
    text-align: center;
    height: 632px;
    padding: 98px 0;

    .title {
      color: #1e2e42;
      font-size: 60px;
      font-weight: 400;
      text-transform: uppercase;
      margin-bottom: 20px;
    }

    p {
      color: #617283;
      font-size: 20px;
      max-width: 619px;
      margin: 0 auto;
      margin-bottom: 70px;
    }

    div {
      span {
        display: inline-flex;
        font-size: 14px;
        text-transform: uppercase;
        line-height: 20px;

        &.autor {
          font-weight: 700;
          border-top: 1px solid #9cafc3;
          padding-top: 30px;
        }

        &.role {
          display: block;
          font-weight: 400;
        }
      }

      img {
        width: 60px;
        margin: 30px 10px;
      }
    }
  }

  #banner {
    display: flex;
    justify-content: center;
    height: 700px;

    div {
      &.photo {
        background: #d8d8d8;
      }

      width: 50%;
      background: #1226aa;
      color: white;
      padding: 40px;
      padding: 150px 0;

      .title {
        color: white;
        text-transform: uppercase;
        font-weight: 400;
        letter-spacing: 1px;
        line-height: 66px;
        font-size: 70px;
        width: 458px;
        margin: 0 auto;
        margin-bottom: 35px;

        &::before {
          content: '';
          display: inline-block;
          width: 6px;
          height: 30px;
          margin-right: 18px;
          background: #2ed9c3;
        }
      }

      p {
        font-size: 20px;
        font-weight: 400;
        width: 458px;
        margin: 0 auto;
      }
    }
  }

  #newsletter {
    .newsletter {
      height: 360px;
      text-align: center;
      background: #f3f5f8;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      &__title {
        color: #1e2e42;
        text-transform: uppercase;
        font-weight: 400;
        font-size: 60px;
        line-height: 70px;
      }

      &__descricao {
        color: #617283;
        font-size: 18px;
        font-weight: 400;
        line-height: 30px;
        width: 100%;
        max-width: 619px;
        margin-bottom: 52px;
      }

      &__form {
        display: block;
        width: 100%;

        .newsletter__input {
          border: 1px solid #bcc9d7;
          padding: 11px 20px;
          width: 100%;
          max-width: 379px;
          border-radius: 4px;
          margin-right: 20px;

          &::placeholder {
            color: #9cafc3;
            font-size: 12px;
            font-family: 'Roboto', sans-serif;
          }
        }

        .newsletter__button {
          color: #fff;
          background: #1226aa;
          text-transform: uppercase;
          border: none;
          padding: 13px;
          border-radius: 90px;
          width: 100%;
          max-width: 127px;
        }
      }
    }
  }

  #footer {
    .footer {
      text-align: center;
      padding: 30px 0;

      &__logo {
        margin-bottom: 46px;
      }

      &__list {
        display: flex;
        text-decoration: none;
        justify-content: center;
        margin: 10px 0;
        list-style: none;
        gap: 15px;

        &-item {
          text-transform: uppercase;
          color: #1e2e42;
          font-size: 14px;
          line-height: 16px;
          font-weight: 400;
        }
      }

      &__descricao {
        color: #617283;
        font-size: 14px;
        width: 100%;
        max-width: 705px;
        line-height: 22px;
        margin: 20px auto;
      }

      &__social {
        display: flex;
        justify-content: center;
        gap: 24px;
      }
    }
  }
}

@media (max-width: 768px) {
  .homePage {
    #header {
      height: 44px;
      padding: 0 12px;

      .container {
        .menu-mobile {
          display: flex;
        }
        .header__link {
          .logo__icon {
            display: none;
          }
        }

        .right-side {
          .nav {
            display: none;
          }

          .header__input {
            height: 24px;
          }

          button {
            width: 92px;
            height: 24px;
          }
        }
      }
    }

    #carousel {
      margin-top: 44px;
    }

    #video {
      flex-direction: column;

      div {
        width: 100%;

        .title {
          font-size: 44px;
        }
      }
    }

    #testemunhos {
      .container {
        height: auto;
        padding: 25px 25px;

        h2 {
          font-size: 18px;
        }

        h1 {
          font-size: 36px;
        }

        .testemunhos {
          flex-direction: column;
          text-align: center;

          .testemunho {
            width: 100%;
          }
        }

        .social {
          text-align: center;
        }
      }
    }

    #planos {
      .container {
        flex-direction: column;
      }
    }

    #donos {
      height: auto;
      padding: 50px 0;

      .title {
        font-size: 44px;
      }
    }

    #banner {
      flex-direction: column;
      height: auto;

      div {
        width: 100%;
        padding: 25px;

        p {
          width: 100%;
        }

        .title {
          font-size: 44px;
        }
      }
    }

    #newsletter {
      .newsletter {
        height: auto;
        padding: 25px;

        &__form {
          .newsletter__input {
            margin-bottom: 12px;
          }
        }
      }
    }
  }
}
</style>